import store from "store";

// let fieldNameSuggestionsObject: string[] | undefined;

// export const setFieldNameSuggestionObject = (
//   suggestions: string[] | undefined
// ) => {
//   fieldNameSuggestionsObject = suggestions;
// };

const provideCompletionItems = (model: any, position: any) => {
  const suggestionObject =
    store.getState().developer.edit.editor.fieldNameSuggestionsObject;

  if (!suggestionObject) {
    return { suggestions: [] };
  }
  // find out if we are completing a property in the 'dependencies' object.
  const textUntilPosition = model.getValueInRange({
    startLineNumber: 1,
    startColumn: 1,
    endLineNumber: position.lineNumber,
    endColumn: position.column,
  });

  const match = textUntilPosition.match(/\t*"name"\s*:\s*".*$/);

  if (!match) {
    return { suggestions: [] };
  }

  const word = model.getWordUntilPosition(position);

  const range = {
    startLineNumber: position.lineNumber,
    endLineNumber: position.lineNumber,
    startColumn: word.startColumn,
    endColumn: word.endColumn,
  };

  return {
    suggestions: suggestionObject.map((suggestion) => {
      return {
        label: suggestion,
        insertText: `${suggestion}`,
        range,
        kind: 3, //Field
      };
    }),
  };
};

export default provideCompletionItems;
